import { Button } from '@cropler/ui-kit';
import i18n from 'i18next';

import styles from './styles.module.scss';

import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';
import { DefaultLanguage } from '../../i18n/constants';
import { WebsiteLanguages } from '../../constants/keys';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const RequestButton = ({ t, text, hideTextOnMobile }) => {
  const { widthViewport } = useViewport();
  const currentLang = i18n.language;
  const requestUrl =
    currentLang === DefaultLanguage || !WebsiteLanguages.includes(currentLang)
      ? `https://www.cropler.io/contact-us`
      : `https://www.cropler.io/${currentLang}/contact-us`;
  return (
    <a className={styles.requestButton} href={requestUrl} target="_blank" rel="noopener noreferrer">
      <Button type="primary" icon={<CroplerIcon name="basket" />} size={widthViewport < BreakpointMobileUp ? 'large' : null}>
        {hideTextOnMobile && widthViewport < BreakpointMobileUp ? null : text || t('actions.orderRequest')}
      </Button>
    </a>
  );
};

export default RequestButton;
